// extracted by mini-css-extract-plugin
export default {"bar":"SearchBar_bar__g68A+","search":"SearchBar_search__6lk44","button":"SearchBar_button__Bu74f","searchIcon":"SearchBar_searchIcon__vaAmX"};